import { Outlet } from 'react-router-dom';

import { BaseLayout } from './BaseLayout';
import { mainContent, footerWrapper } from './Layout.css';
import { PageFooter } from './PageFooter';

export function PublicLayout() {
  return (
    <BaseLayout
      className={mainContent}
      footer={
        <div className={footerWrapper}>
          <PageFooter />
        </div>
      }
    >
      <Outlet />
    </BaseLayout>
  );
}
